import axios from 'axios';
import { getTimeZoneDate, getTimeZoneDateStart } from '../helpers/Util';

export const getSales = async ({ headers, eventId, eventDate, start, end }) => {
  try {
    let url = `${process.env.REACT_APP_API_REPORT_BASE_URL}/${eventId}/sales`;
    if (eventDate) {
      url += `?eventDate=${eventDate}`;
    }

    if (start && end) {
      url += `${url.indexOf('?') === -1 ? '?' : '&'}start=${start}&end=${end}`;
    }

    const response = await axios.get(url, { headers });

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const getOrders = async ({ headers, eventId, eventDate, start, end }) => {
  try {
    let url = `${process.env.REACT_APP_API_REPORT_BASE_URL}/${eventId}/sales/order`;
    if (eventDate) {
      url += `?eventDate=${eventDate}`;
    }

    if (start && end) {
      url += `${url.indexOf('?') === -1 ? '?' : '&'}start=${start}&end=${end}`;
    }

    const response = await axios.get(url, { headers });

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const getOrder = async ({ headers, eventId, orderId }) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_REPORT_BASE_URL}/${eventId}/sales/order/${orderId}`,
      { headers }
    );

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const getDailySales = async ({ headers, eventId, eventDate }) => {
  try {
    const startDate = getTimeZoneDateStart({ date: new Date() }).subtract(30, 'day');
    const endDate = getTimeZoneDate({ date: new Date() });
    const start = startDate.toISOString();
    const end = endDate.toISOString();

    let url = `${process.env.REACT_APP_API_REPORT_BASE_URL}/${eventId}/sales/daily?start=${start}&end=${end}`;
    if (eventDate) {
      url += `&eventDate=${eventDate}`;
    }

    const response = await axios.get(url, { headers });

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const getEntryList = async ({ headers, eventId, eventDate, start, end }) => {
  try {
    let url = `${process.env.REACT_APP_API_REPORT_BASE_URL}/${eventId}/entries/list`;
    if (eventDate) {
      url += `?eventDate=${eventDate}`;
    }

    if (start && end) {
      url += `${url.indexOf('?') === -1 ? '?' : '&'}start=${start}&end=${end}`;
    }

    const response = await axios.get(url, { headers });

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const getEntries = async ({ headers, eventId, eventDate, start, end }) => {
  try {
    let url = `${process.env.REACT_APP_API_REPORT_BASE_URL}/${eventId}/entries`;
    if (eventDate) {
      url += `?eventDate=${eventDate}`;
    }

    if (start && end) {
      url += `${url.indexOf('?') === -1 ? '?' : '&'}start=${start}&end=${end}`;
    }

    const response = await axios.get(url, { headers });

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const getTimeEntries = async ({ headers, eventId, eventDate, start, end }) => {
  try {
    let url = `${process.env.REACT_APP_API_REPORT_BASE_URL}/${eventId}/entries/time`;
    if (eventDate) {
      url += `?eventDate=${eventDate}`;
    }

    if (!(start && end)) {
      const startDate = getTimeZoneDateStart({ date: new Date() }).subtract(30, 'day');
      const endDate = getTimeZoneDate({ date: new Date() });
      start = startDate.toISOString();
      end = endDate.toISOString();
    }

    url += `${url.indexOf('?') === -1 ? '?' : '&'}start=${start}&end=${end}`;

    const response = await axios.get(url, { headers });

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const getEntry = async ({ headers, eventId, entryId }) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_REPORT_BASE_URL}/${eventId}/entries/entry/${entryId}`,
      { headers }
    );

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
